import { render, staticRenderFns } from "./RuleItemGroup.vue?vue&type=template&id=0804effa&scoped=true"
import script from "./RuleItemGroup.vue?vue&type=script&lang=js"
export * from "./RuleItemGroup.vue?vue&type=script&lang=js"
import style0 from "./RuleItemGroup.vue?vue&type=style&index=0&id=0804effa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0804effa",
  null
  
)

export default component.exports